import { AnyAction, Reducer } from 'redux';
import {
  ACTION,
  RequestCodetableAccess, ReceiveCodetableAccess, FailCodetableAccess,
  RequestHierarchy, ReceiveHierarchy, FailHierarchy
} from './action-types';
import { CodetableAccessState } from './types-store';

export const INITIAL_STATE: CodetableAccessState = {
  codetableAccess: [],
  fetching: [],
  hierarchy: undefined,
  fetchingHierarchy: false,
  forbiddenAccess: false
};

const reducers: { [indexer: string]: Reducer<CodetableAccessState> } = {

  [ACTION.REQUEST_CODETABLE_ACCESS]: (state: CodetableAccessState, action: RequestCodetableAccess): CodetableAccessState => {

    return {
      ...state,
      codetableAccess: (state.codetableAccess || []).filter(access => access.id !== action.codetableId),
      fetching: !(state.fetching || []).includes(action.codetableId)
        ? [
          ...state.fetching,
          action.codetableId
        ]
        : state.fetching
    };
  },

  [ACTION.RECEIVE_CODETABLE_ACCESS]: (state: CodetableAccessState, action: ReceiveCodetableAccess): CodetableAccessState => {

    if (!(state.fetching || []).includes(action.codetableId)) {
      return state;
    }

    return {
      ...state,
      codetableAccess: [
        ...(state.codetableAccess || []).filter(access => access.id !== action.codetableId),
        action.codetableAccess
      ]
    };
  },

  [ACTION.FAIL_CODETABLE_ACCESS]: (state: CodetableAccessState, action: FailCodetableAccess): CodetableAccessState => {

    if (!(state.fetching || []).includes(action.codetableId)) {
      return state;
    }

    return {
      ...state,
      codetableAccess: (state.codetableAccess || []).filter(access => access.id !== action.codetableId),
      fetching: state.fetching.filter(codetableId => codetableId !== action.codetableId)
    };
  },

  [ACTION.REQUEST_HIERARCHY]: (state: CodetableAccessState, action: RequestHierarchy): CodetableAccessState => {

    return {
      ...state,
      fetchingHierarchy: true
    };
  },

  [ACTION.RECEIVE_HIERARCHY]: (state: CodetableAccessState, action: ReceiveHierarchy): CodetableAccessState => {

    return {
      ...state,
      hierarchy: action.hierarchy,
      fetchingHierarchy: false
    };
  },

  [ACTION.FAIL_HIERARCHY]: (state: CodetableAccessState, action: FailHierarchy): CodetableAccessState => {

    return {
      ...state,
      fetchingHierarchy: false
    };
  },

  [ACTION.FORBIDDEN_ACCESS]: (state: CodetableAccessState, action: FailHierarchy): CodetableAccessState => {

    return {
      ...state,
      forbiddenAccess: true
    };
  }
};

export const reducer: Reducer<CodetableAccessState> = (
  state: CodetableAccessState = INITIAL_STATE, action: AnyAction) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
